// Only these residences require a state/province, each under its local name.
// Everywhere else keeps the generic label and the field is optional (ENG-2349).
const REQUIRED_STATE_FIELDS = {
  us: Object.freeze({ label: "State", required: true }),
  ca: Object.freeze({ label: "Province / Territory", required: true }),
  au: Object.freeze({ label: "State / Territory", required: true }),
};

const DEFAULT_STATE_FIELD = Object.freeze({
  label: "State/Province",
  required: false,
});

export function stateFieldFor(isoCode) {
  const code = String(isoCode || "").trim().toLowerCase();
  return REQUIRED_STATE_FIELDS[code] || DEFAULT_STATE_FIELD;
}
